import { Location } from '@plvs/client-data/models'
import { generatePath } from 'react-router-dom'
import React from 'react'
import { BracketPhase } from '@plvs/respawn/containers/bracket/hooks/useProcessedRounds.utils'
import {
  BracketMatch,
  NxBracket,
} from '@plvs/respawn/components/bracket/Bracket'

function getCheckpointLinks(
  schoolId?: string,
  teamId?: string,
  matchId?: string
): { schoolLink: string; teamLink: string; matchLink: string } {
  let schoolLink: string = ''
  let matchLink: string = ''
  let teamLink: string = ''

  if (schoolId) {
    schoolLink = generatePath('/school/:id/info', {
      id: schoolId,
    })
  }
  if (teamId) {
    teamLink = generatePath('/team/:id', {
      id: teamId,
    })
  }
  if (matchId) {
    matchLink = generatePath('/match/:id', {
      id: matchId,
    })
  }
  return { schoolLink, teamLink, matchLink }
}

function getRallyLinks(
  isLoggedIn: boolean,
  schoolSlug?: string,
  teamId?: string,
  matchId?: string
): { schoolLink: string; teamLink: string; matchLink: string } {
  let schoolLink: string = ''
  let matchLink: string = ''
  let teamLink: string = ''
  if (schoolSlug) {
    const path = isLoggedIn ? '/app/school/:slug' : '/org/:slug'
    schoolLink = generatePath(path, {
      slug: schoolSlug,
    })
  }
  if (teamId) {
    const path = isLoggedIn ? '/app/team/:id' : '/team/:id'
    teamLink = generatePath(path, {
      id: teamId,
    })
  }
  if (matchId) {
    const path = '/app/match/:id'
    matchLink = generatePath(path, {
      id: matchId,
    })
  }

  return { schoolLink, teamLink, matchLink }
}

export function getLinks(
  location: Location,
  isLoggedIn: boolean,
  schoolSlug?: string,
  schoolId?: string,
  teamId?: string,
  matchId?: string
): { schoolLink: string; teamLink: string; matchLink: string } {
  const schoolLink: string = ''
  let matchLink: string = ''
  const teamLink: string = ''
  if (location === Location.Rally) {
    return getRallyLinks(isLoggedIn, schoolSlug, teamId, matchId)
  }

  if (location === Location.Checkpoint) {
    return getCheckpointLinks(schoolId, teamId, matchId)
  }

  if (location === Location.Stadium) {
    if (matchId) {
      matchLink = generatePath('/app/match/:id', {
        id: matchId,
      })
    }
  }

  return { schoolLink, teamLink, matchLink }
}

type GetBracketProps = {
  overlayColor: string
  rounds: BracketMatch[][]
  upperRounds: BracketMatch[][]
  lowerRounds: BracketMatch[][]
  finalRounds: BracketMatch[][]
  isDoubleElimination: boolean
  bracketPhase: BracketPhase | null
}

export function getBracketComponent({
  overlayColor,
  rounds,
  isDoubleElimination,
  bracketPhase,
  upperRounds,
  lowerRounds,
  finalRounds,
}: GetBracketProps): React.ReactElement {
  if (isDoubleElimination) {
    if (bracketPhase === BracketPhase.Lower) {
      return (
        <NxBracket
          isDoubleElimination={isDoubleElimination}
          overlayColor={overlayColor}
          rounds={lowerRounds}
        />
      )
    }

    if (bracketPhase === BracketPhase.Upper) {
      return (
        <NxBracket
          isDoubleElimination={isDoubleElimination}
          overlayColor={overlayColor}
          rounds={upperRounds}
        />
      )
    }

    if (bracketPhase === BracketPhase.Finals) {
      return (
        <NxBracket
          isDoubleElimination={isDoubleElimination}
          overlayColor={overlayColor}
          rounds={finalRounds}
        />
      )
    }
  }

  return (
    <NxBracket
      isDoubleElimination={isDoubleElimination}
      overlayColor={overlayColor}
      rounds={rounds}
    />
  )
}
